import React, { useEffect, useState } from "react";
import { Panel, Field } from "@/pages/admin/shared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Save, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/pages/admin/api";

export default function Profile() {
  const [me, setMe] = useState(null);
  const [pwForm, setPwForm] = useState({ current_password: "", new_password: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/profile").then((r) => setMe(r.data)); }, []);
  if (!me) return <div className="text-sm text-muted-foreground">Loading…</div>;

  const saveProfile = async () => {
    setSaving(true);
    try { const r = await api.put("/profile", { name: me.name, email: me.email }); setMe(r.data); toast.success("Profile updated"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };

  const changePw = async () => {
    if (pwForm.new_password.length < 6) return toast.error("Password must be at least 6 characters");
    try {
      await api.post("/auth/change-password", pwForm);
      toast.success("Password changed");
      setPwForm({ current_password: "", new_password: "" });
    } catch (err) { toast.error(err?.response?.data?.detail || "Change failed"); }
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <Panel title="Profile" actions={<Button data-testid="save-profile" onClick={saveProfile} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><Save size={14} className="mr-1" /> {saving ? "Saving..." : "Save"}</Button>}>
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Name"><Input value={me.name || ""} onChange={(e) => setMe({ ...me, name: e.target.value })} /></Field>
          <Field label="Email"><Input type="email" value={me.email || ""} onChange={(e) => setMe({ ...me, email: e.target.value })} /></Field>
          <Field label="Username"><Input value={me.username || ""} readOnly className="bg-slate-50 dark:bg-slate-800" /></Field>
          <Field label="Role"><Input value={me.role || "administrator"} readOnly className="bg-slate-50 dark:bg-slate-800" /></Field>
        </div>
      </Panel>

      <Panel title="Change Password">
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Current Password"><Input type="password" value={pwForm.current_password} onChange={(e) => setPwForm({ ...pwForm, current_password: e.target.value })} /></Field>
          <Field label="New Password" hint="Min. 6 characters"><Input type="password" value={pwForm.new_password} onChange={(e) => setPwForm({ ...pwForm, new_password: e.target.value })} /></Field>
        </div>
        <Button data-testid="change-password" onClick={changePw} className="mt-4 rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><KeyRound size={14} className="mr-1" /> Update Password</Button>
      </Panel>
    </div>
  );
}
